import api from './api';

/**
 * Banner Service (Admin Panel)
 */

// ==================== SLOT MANAGEMENT ====================

export const createBannerSlot = async (data: any) => {
  // api methods already extract response.data.data automatically
  const response = await api.post('/admin/banners/slots', data) as any;
  return response;
};

export const getAllBannerSlots = async (params?: any) => {
  // api.get already extracts response.data.data automatically
  const response = await api.get('/admin/banners/slots', { params }) as any;
  return response;
};

export const getBannerSlotById = async (id: string) => {
  const response = await api.get(`/admin/banners/slots/${id}`) as any;
  return response;
};

export const updateBannerSlot = async (id: string, data: any) => {
  const response = await api.put(`/admin/banners/slots/${id}`, data) as any;
  return response;
};

export const deleteBannerSlot = async (id: string) => {
  const response = await api.delete(`/admin/banners/slots/${id}`) as any;
  return response;
};

export const toggleSlotActive = async (id: string, isActive: boolean) => {
  const response = await api.patch(`/admin/banners/slots/${id}/toggle-active`, { isActive }) as any;
  return response;
};

// ==================== RESERVATION MANAGEMENT ====================

export const getAllReservations = async (params?: any) => {
  const response = await api.get('/admin/banners/reservations', { params }) as any;
  return response;
};

export const getPendingReservations = async (params?: any) => {
  const response = await api.get('/admin/banners/reservations/pending', { params }) as any;
  return response;
};

export const getReservationById = async (id: string) => {
  const response = await api.get(`/admin/banners/reservations/${id}`) as any;
  return response;
};

export const approveReservation = async (id: string) => {
  const response = await api.post(`/admin/banners/reservations/${id}/approve`, {}) as any;
  return response;
};

export const rejectReservation = async (id: string, data: { rejectionReason: string }) => {
  const response = await api.post(`/admin/banners/reservations/${id}/reject`, data) as any;
  return response;
};

export const approveEditRequest = async (id: string) => {
  const response = await api.post(`/admin/banners/reservations/${id}/edit-request/approve`, {}) as any;
  return response;
};

export const rejectEditRequest = async (id: string, data: { reason: string }) => {
  const response = await api.post(`/admin/banners/reservations/${id}/edit-request/reject`, data) as any;
  return response;
};

export const toggleBannerPause = async (id: string, data: { isPaused: boolean; reason?: string }) => {
  const response = await api.patch(`/admin/banners/reservations/${id}/toggle-pause`, data) as any;
  return response;
};

// ==================== CONFLICT RESOLUTION ====================

export const cancelReservation = async (id: string, data?: { reason?: string }) => {
  const response = await api.post(`/admin/banners/reservations/${id}/cancel`, data || {}) as any;
  return response;
};

export const cleanupStaleReservations = async () => {
  const response = await api.post('/admin/banners/cleanup') as any;
  return response;
};

export const resolveSlotConflicts = async (slotId: string) => {
  const response = await api.post(`/admin/banners/slots/${slotId}/resolve-conflicts`) as any;
  return response;
};

// ==================== ANALYTICS ====================

export const getSystemAnalytics = async (params?: any) => {
  const response = await api.get('/admin/banners/analytics/overview', { params }) as any;
  return response;
};

export const compareBanners = async (params: { reservationIds: string; startDate?: string; endDate?: string }) => {
  const response = await api.get('/admin/banners/analytics/compare', { params }) as any;
  return response;
};

// ==================== PAYMENT ====================

export const refundPayment = async (id: string, data: { reason: string }) => {
  const response = await api.post(`/admin/banners/payments/${id}/refund`, data) as any;
  return response;
};

// ==================== AUTOMATION ====================

export const activateScheduledBanners = async () => {
  const response = await api.post('/admin/banners/cron/activate') as any;
  return response;
};

export const expireFinishedBanners = async () => {
  const response = await api.post('/admin/banners/cron/expire') as any;
  return response;
};

// ==================== ADMIN BANNERS (بنرهای ادمین - بدون پرداخت) ====================

export const createAdminBanner = async (data: any) => {
  const response = await api.post('/admin/banners/create', data) as any;
  return response;
};

export const getAdminBanners = async (params?: any) => {
  const response = await api.get('/admin/banners/my-banners', { params }) as any;
  return response;
};

export const updateAdminBanner = async (id: string, data: any) => {
  const response = await api.put(`/admin/banners/my-banners/${id}`, data) as any;
  return response;
};

export const deleteAdminBanner = async (id: string) => {
  const response = await api.delete(`/admin/banners/my-banners/${id}`) as any;
  return response;
};

export const toggleAdminBannerVisibility = async (id: string, isVisible: boolean) => {
  const response = await api.patch(`/admin/banners/my-banners/${id}/toggle-visibility`, { isVisible }) as any;
  return response;
};

